import React from 'react'

export default function Astreix({ label }) {
  return (
      <>
      {label}
    <span
      style={{
          fontSize: "20px",
          color: "#6C63FF",
          
        }}
        >
      *
    </span>
        </>
  );
}
